import React from "react";
import {observer} from 'mobx-react';

import style from "./SafetyTab.lazy.css";

@observer
class SafetyTab extends React.Component {
    pageKey = "SafetyTab";

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        style.use();
    }

    componentWillUnmount() {
        style.unuse();
    }

    render() {
        return <div id={this.pageKey + "-tab"} className={this.pageKey + "-tab"}>
            <iframe src="https://rhespo.rocket.chat/channel/safety?layout=embedded" width="100%" height="100%"/>
        </div>
    }
}

export default SafetyTab;
